import fromAnyToBool from 'utils/converters/fromAnyToBool.util';
import fromAnyToString from 'utils/converters/fromAnyToString';

export const fromCreateTaxToDto = (tax) => ({
  name: fromAnyToString(tax.name),
  percentage: fromAnyToString(tax.percentage),
  applied_to: fromAnyToString(tax.appliedTo),
  is_default: fromAnyToBool(tax.isDefault),
  apply_to_existing: fromAnyToBool(tax.applyToExisting),
});

export const fromEditTaxToDto = (tax) => ({
  name: fromAnyToString(tax.name),
  percentage: fromAnyToString(tax.percentage),
});
